module.exports = ".inline {\n    display: inline;\n}\n\n.nav-btn {\n    margin-left: 5px;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/custom-topics/custom-topics.component.css
// module id = ./src/app/agora/components/product-data/custom-topics/custom-topics.component.css
// module chunks = main